import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ChevronDown, ChevronUp, HelpCircle } from "lucide-react";

const FAQ_DATA = [
  {
    category: "Credits",
    questions: [
      { q: "Comment gagner des credits ?", a: "Tu gagnes des credits en te connectant chaque jour (streak), en votant dans les sondages (+3), en completant des defis, en parrainant des amis (+100), ou en les achetant dans la boutique." },
      { q: "A quoi servent les credits ?", a: "Les credits permettent de miser sur tes artistes preferes pour augmenter leur cote, et d'echanger contre des recompenses exclusives proposees par les artistes (dedicaces, merch, concerts...)." },
      { q: "Les credits sont-ils remboursables ?", a: "Non, les credits achetes ne sont pas remboursables. Les mises placees sont definitives." },
    ],
  },
  {
    category: "Mises & Classement",
    questions: [
      { q: "Comment miser sur un artiste ?", a: "Rendez-vous sur le profil d'un artiste et utilisez le formulaire de mise. Plus tu mises, plus tu montes dans le classement des Top Miseurs de cet artiste." },
      { q: "Comment fonctionne le classement ?", a: "Les artistes sont classes selon leur score total (somme de toutes les mises). Le classement est mis a jour en temps reel." },
    ],
  },
  {
    category: "Recompenses",
    questions: [
      { q: "Comment echanger une recompense ?", a: "Va dans la boutique (Shop), choisis une recompense et clique sur 'Echanger'. Les credits seront deduits de ton solde." },
      { q: "Que se passe-t-il apres un echange ?", a: "L'artiste recoit une notification et doit honorer la recompense. Tu peux suivre le statut dans 'Mes echanges'." },
    ],
  },
  {
    category: "Defis",
    questions: [
      { q: "Comment participer a un defi ?", a: "Va dans l'onglet Defis, choisis un defi actif et clique sur 'Participer'. Decris ta participation et/ou ajoute un lien. L'artiste validera ta soumission." },
      { q: "Combien de credits je gagne ?", a: "Chaque defi a sa propre recompense en credits. Tu les recois des que l'artiste valide ta participation." },
    ],
  },
  {
    category: "Parrainage",
    questions: [
      { q: "Comment parrainer un ami ?", a: "Va dans ton profil, copie ton code de parrainage et partage-le. Quand ton ami s'inscrit avec ton code, tu gagnes 100 credits et lui 50." },
    ],
  },
  {
    category: "Badges & Niveaux",
    questions: [
      { q: "Comment debloquer des badges ?", a: "Les badges se debloquent automatiquement quand tu atteins certains seuils d'activite (mises, echanges, parrainages, streak...)." },
      { q: "Comment monter de niveau ?", a: "Ton niveau augmente avec tes XP, gagnes en etant actif sur la plateforme. Plus tu participes, plus tu montes." },
    ],
  },
  {
    category: "Compte & Signalement",
    questions: [
      { q: "Comment signaler un contenu ?", a: "Contacte l'equipe via la page de ton profil ou signale directement le contenu inapproprie." },
      { q: "Comment supprimer mon compte ?", a: "Pour l'instant, contacte le support pour toute demande de suppression de compte." },
    ],
  },
];

export default function HelpPage() {
  const navigate = useNavigate();
  const [openItems, setOpenItems] = useState({});

  const toggle = (key) => {
    setOpenItems((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className="py-6 space-y-5" data-testid="help-page">
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-sm text-muted-foreground hover:text-[#FF6B35] transition-colors"
      >
        <ArrowLeft className="w-4 h-4" />
        Retour
      </button>

      <div>
        <h1 className="font-heading font-black text-2xl text-foreground">Aide & FAQ</h1>
        <p className="text-sm text-muted-foreground mt-1">Tout ce qu'il faut savoir sur ReallyFan</p>
      </div>

      {FAQ_DATA.map((cat) => (
        <div key={cat.category} className="bg-card border border-border rounded-3xl overflow-hidden shadow-sm">
          <div className="px-5 py-3 border-b border-border">
            <h2 className="font-heading font-bold text-sm text-card-foreground">{cat.category}</h2>
          </div>
          {cat.questions.map((item, i) => {
            const key = `${cat.category}-${i}`;
            const isOpen = openItems[key];
            return (
              <div key={key} className="border-b border-border last:border-0">
                <button
                  onClick={() => toggle(key)}
                  className="w-full flex items-center justify-between px-5 py-3 text-left hover:bg-muted transition-colors"
                  data-testid={`faq-${key}`}
                >
                  <span className="text-xs text-card-foreground font-medium pr-4">{item.q}</span>
                  {isOpen ? (
                    <ChevronUp className="w-4 h-4 text-muted-foreground shrink-0" />
                  ) : (
                    <ChevronDown className="w-4 h-4 text-muted-foreground shrink-0" />
                  )}
                </button>
                {isOpen && (
                  <div className="px-5 pb-3">
                    <p className="text-xs text-card-foreground/80 leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
